import React from "react";
import { Button, Result } from "antd";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  componentWillReceiveProps = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="500"
          title="500"
          subTitle="Internal Server Error!"
          extra={
            <Button
              type="primary"
              onClick={() => this.setState({ hasError: false })}
            >
              Дахин ачаалах
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
